export interface Manga {
  id: string;
  title: string;
  cover: string;
  author: string;
  genres: string[];
  status: string;
  score: number;
  description: string;
  latestChapter: string;
  chapters: number;
  updateTime: string;
  views: string;
  updateFrequency: string;
}

export interface Genre {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const GENRES: Genre[] = [
  { id: 'rexue', name: '热血', icon: 'ri-fire-fill', desc: '燃烧的少年斗志与燃向战斗' },
  { id: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-fill', desc: '轻松解压的爆笑日常' },
  { id: 'shaonv', name: '少女漫', icon: 'ri-heart-3-fill', desc: '甜蜜心动与细腻情感' },
  { id: 'shaonian', name: '少年漫', icon: 'ri-sword-fill', desc: '冒险、友情与成长' },
  { id: 'wanjie', name: '完结', icon: 'ri-check-double-line', desc: '全部章节完结，一次看个够' },
  { id: 'hanzu', name: '汉化组', icon: 'ri-translate-2', desc: '精选优质汉化作品' },
];

export const MANGAS: Manga[] = [
  {
    id: 'lieyan-qishituan',
    title: '烈焰骑士团',
    author: '苍焰工作室',
    genres: ['热血', '少年漫'],
    status: '连载中',
    score: 9.4,
    description: '王国覆灭之夜，少年亚瑟背负着燃烧的徽记踏上复兴之路。他与残存的骑士团成员穿梭于战火之中，用热血与信念点燃整片大陆的希望之光。',
    latestChapter: '第216话 王都的抉择',
    chapters: 216,
    updateTime: '2小时前',
    views: '1280万',
    updateFrequency: '每周三、周六更新',
  },
  {
    id: 'wuxia-jianying',
    title: '剑影江湖',
    author: '墨尘',
    genres: ['少年漫', '热血'],
    status: '连载中',
    score: 9.1,
    description: '落魄书生误入腥风血雨的江湖，无意间习得失传剑法。一路行侠仗义、快意恩仇，在刀光剑影中揭开笼罩武林数十年的巨大阴谋。',
    latestChapter: '第98话 青楼惊变',
    chapters: 98,
    updateTime: '5小时前',
    views: '860万',
    updateFrequency: '每周二更新',
  },
  {
    id: 'xiuxian-jishi',
    title: '修仙纪元',
    author: '临渊',
    genres: ['热血', '少年漫'],
    status: '连载中',
    score: 8.9,
    description: '凡人少年偶得上古残卷，开启逆天修仙之路。从山村少年到俯瞰众生，一场跨越千年的修仙纪元徐徐展开，热血燃魂。',
    latestChapter: '第412话 渡劫飞升',
    chapters: 412,
    updateTime: '昨天',
    views: '2350万',
    updateFrequency: '每日更新',
  },
  {
    id: 'zhanchao-zhiwang',
    title: '斩潮之王',
    author: '浪人',
    genres: ['热血'],
    status: '连载中',
    score: 9.0,
    description: '海浪之子为守护渔村踏上竞技舞台，在层层挑战中不断变强。以剑斩潮，以信念破浪，一场关于尊严与热血的战斗正式开始。',
    latestChapter: '第77话 剑试锋芒',
    chapters: 77,
    updateTime: '3小时前',
    views: '540万',
    updateFrequency: '每周一、周五更新',
  },
  {
    id: 'lianqin-xiaosheng',
    title: '炼金小生',
    author: '北巷',
    genres: ['搞笑', '热血'],
    status: '连载中',
    score: 8.7,
    description: '见习炼金术师立志成为世界第一，却总是把药水炼成炸弹、把魔法阵画成涂鸦。一部笑料百出却又充满热血的爆笑成长记。',
    latestChapter: '第156话 奇怪的顾客',
    chapters: 156,
    updateTime: '昨天',
    views: '920万',
    updateFrequency: '每周四更新',
  },
  {
    id: 'shangban-guy',
    title: '社畜也要当勇者',
    author: '摸鱼社',
    genres: ['搞笑', '汉化组'],
    status: '连载中',
    score: 8.8,
    description: '加班到崩溃的社畜被异世界召唤成为勇者，却只想准时下班、顺利摸鱼。在魔王城与办公室之间反复横跳的无厘头冒险。',
    latestChapter: '第88话 加班魔王',
    chapters: 88,
    updateTime: '4小时前',
    views: '670万',
    updateFrequency: '每周三更新',
  },
  {
    id: 'mao-xiaofan',
    title: '猫咪大厨的深夜食堂',
    author: '鱼丸汤',
    genres: ['搞笑', '少女漫'],
    status: '连载中',
    score: 8.9,
    description: '一只会做饭的橘猫在深夜小巷经营小食堂，用一道道暖心料理治愈形形色色的客人。温馨搞笑的治愈系日常，笑中带泪。',
    latestChapter: '第203话 夏日的刨冰',
    chapters: 203,
    updateTime: '6小时前',
    views: '1580万',
    updateFrequency: '每周五更新',
  },
  {
    id: 'shufang-yaoqing',
    title: '放学后的告白',
    author: '盛夏',
    genres: ['少女漫', '汉化组'],
    status: '连载中',
    score: 9.2,
    description: '内向少女与篮球社王牌从误会开始的校园恋爱。每一次擦肩、每一张纸条，都在悄悄累积成无法言说的心动。甜度满分。',
    latestChapter: '第45话 心跳的约定',
    chapters: 45,
    updateTime: '1小时前',
    views: '760万',
    updateFrequency: '每周日更新',
  },
  {
    id: 'xingkong-shaonv',
    title: '星空下的少女',
    author: '未眠',
    genres: ['少女漫'],
    status: '已完结',
    score: 9.0,
    description: '转学生少女在星空观测社结识了沉默的天才少年。两个孤独的灵魂在浩瀚星空下慢慢靠近，书写一段清澈又动人的青春物语。',
    latestChapter: '全92话 完结',
    chapters: 92,
    updateTime: '已完结',
    views: '1120万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'chunfeng-shi',
    title: '春风吹过的校园',
    author: '南栀',
    genres: ['少女漫', '完结'],
    status: '已完结',
    score: 8.8,
    description: '从青涩懵懂到并肩前行，两位青梅竹马在四季流转中读懂彼此。细腻温柔的情感描写，唤醒每个人心里那段纯真的校园回忆。',
    latestChapter: '全68话 完结',
    chapters: 68,
    updateTime: '已完结',
    views: '890万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'dongyu-zhanshi',
    title: '冬雨战士',
    author: '冷锋',
    genres: ['少年漫', '热血'],
    status: '已完结',
    score: 9.3,
    description: '在终年积雪的冰原，一名背负诅咒的战士踏上寻找自我的旅程。经典的热血王道之作，友情、牺牲与成长交织成不朽传奇。',
    latestChapter: '全314话 完结',
    chapters: 314,
    updateTime: '已完结',
    views: '3160万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'yizhan-juexing',
    title: '一战觉醒',
    author: '曙光',
    genres: ['少年漫', '汉化组'],
    status: '已完结',
    score: 8.6,
    description: '异能觉醒的时代，少年在废土中寻找人类最后的希望。宏大的世界观与密集的战斗，一口气读完的畅快体验。',
    latestChapter: '全120话 完结',
    chapters: 120,
    updateTime: '已完结',
    views: '940万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'tianshi-zhige',
    title: '天使之阁',
    author: '白羽',
    genres: ['少女漫', '搞笑'],
    status: '连载中',
    score: 8.5,
    description: '凡人少女误打误撞成为天使之阁的见习天使，在降妖除魔与柴米油盐之间来回切换。清新爆笑的奇幻日常。',
    latestChapter: '第134话 出逃的恶魔',
    chapters: 134,
    updateTime: '昨天',
    views: '610万',
    updateFrequency: '每周六更新',
  },
  {
    id: 'miao-xie-meng',
    title: '喵写梦',
    author: '橘子汽水',
    genres: ['搞笑', '少女漫'],
    status: '连载中',
    score: 8.4,
    description: '当熬夜写稿的漫画家发现自己笔下角色全都活了过来，还赖在家里不肯走……脑洞大开又笑点密集的沙雕日常。',
    latestChapter: '第59话 主角罢工了',
    chapters: 59,
    updateTime: '8小时前',
    views: '480万',
    updateFrequency: '每周二更新',
  },
  {
    id: 'junying-mohan',
    title: '军影默寒',
    author: '朔风',
    genres: ['热血', '汉化组'],
    status: '连载中',
    score: 9.0,
    description: '战火纷飞的架空大陆，天才指挥官与麾下精锐小队执行最危险的任务。紧张刺激的战术博弈与生死与共的兄弟情谊。',
    latestChapter: '第167话 背水一战',
    chapters: 167,
    updateTime: '3小时前',
    views: '1030万',
    updateFrequency: '每周一更新',
  },
  {
    id: 'heizhuang-xiaowu',
    title: '黑装小队',
    author: '隐客',
    genres: ['搞笑', '热血'],
    status: '已完结',
    score: 8.7,
    description: '一支穿着黑西装却总把事情搞砸的「精英」小队，在无数乌龙任务中意外守护了世界和平。爆笑与热血并存的口碑之作。',
    latestChapter: '全175话 完结',
    chapters: 175,
    updateTime: '已完结',
    views: '720万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'mengxiang-jiaolian',
    title: '梦想教练',
    author: '绿茵',
    genres: ['少年漫', '热血'],
    status: '连载中',
    score: 8.9,
    description: '退役球星执教一支不被看好的校园球队，带领孩子们在绿茵场上追逐足球梦想。汗水与泪水交织的青春运动物语。',
    latestChapter: '第289话 决赛之前',
    chapters: 289,
    updateTime: '昨天',
    views: '1320万',
    updateFrequency: '每周四更新',
  },
  {
    id: 'banquet-julang',
    title: '宴席上的飓风',
    author: '味觉风暴',
    genres: ['热血', '搞笑'],
    status: '已完结',
    score: 8.8,
    description: '天才厨师立志用料理征服世界，在各国名厨的挑战中不断突破极限。酣畅淋漓的美食对决，看得人胃口大开。',
    latestChapter: '全143话 完结',
    chapters: 143,
    updateTime: '已完结',
    views: '680万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'xunluo-zhanshi',
    title: '巡夜者',
    author: '夜枭',
    genres: ['少年漫'],
    status: '连载中',
    score: 8.6,
    description: '城市暗影中潜伏着未知的存在，少年巡夜者在霓虹与月色之间维护着平凡人的安宁。都市奇幻与动作的完美结合。',
    latestChapter: '第121话 血色街角',
    chapters: 121,
    updateTime: '6小时前',
    views: '590万',
    updateFrequency: '每周五更新',
  },
  {
    id: 'xiaoyu-qingge',
    title: '小屿情歌',
    author: '海岸线',
    genres: ['少女漫', '汉化组'],
    status: '连载中',
    score: 8.9,
    description: '回到海边故乡的少女，重遇少年时的邻家伙伴。潮起潮落间，那些没说出口的心意终于随着夏日的晚风一起浮出水面。',
    latestChapter: '第38话 海边烟火',
    chapters: 38,
    updateTime: '2小时前',
    views: '520万',
    updateFrequency: '每周日更新',
  },
  {
    id: 'tiedao-xiaoyuan',
    title: '铁道少年团',
    author: '班次',
    genres: ['少年漫', '搞笑'],
    status: '已完结',
    score: 8.5,
    description: '一群少年志愿者守护着山间小站，在迎来送往的列车声中收获友情与成长。轻松治愈，充满人情味的温暖故事。',
    latestChapter: '全96话 完结',
    chapters: 96,
    updateTime: '已完结',
    views: '450万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'jueyan-fenghuo',
    title: '绝焰烽火',
    author: '赤炎',
    genres: ['热血', '少年漫'],
    status: '连载中',
    score: 9.2,
    description: '边境孤城被围困，少年守将凭一把绝焰剑力挽狂澜。铁血与柔情并存，热血拉满的战争史诗，目前正处巅峰剧情。',
    latestChapter: '第238话 血战沙场',
    chapters: 238,
    updateTime: '1小时前',
    views: '1890万',
    updateFrequency: '每日更新',
  },
  {
    id: 'guangnian-waixing',
    title: '光年之外',
    author: '星际尘埃',
    genres: ['少年漫', '完结'],
    status: '已完结',
    score: 9.1,
    description: '当人类踏足光年之外的殖民星，一名年轻领航员在陌生星球上开启了冒险。硬核科幻与温柔情感的跨界融合。',
    latestChapter: '全201话 完结',
    chapters: 201,
    updateTime: '已完结',
    views: '1260万',
    updateFrequency: '全篇完结',
  },
  {
    id: 'tonghua-shi',
    title: '童话事务所',
    author: '圆滚滚',
    genres: ['搞笑', '少女漫'],
    status: '连载中',
    score: 8.6,
    description: '童话角色们下岗再就业，在「童话事务所」里接单解决各种离奇委托。无厘头的笑点与温暖人心的故事完美融合。',
    latestChapter: '第102话 走错片场的灰姑娘',
    chapters: 102,
    updateTime: '5小时前',
    views: '570万',
    updateFrequency: '每周三更新',
  },
  {
    id: 'yunshang-jianxian',
    title: '云上剑仙',
    author: '青崖',
    genres: ['热血', '汉化组'],
    status: '连载中',
    score: 9.3,
    description: '御剑飞行、斩妖除魔的仙侠世界，山村少年拜入剑宗，一路历练成长。行云流水的打斗与宏大的仙侠格局，近期人气飙升。',
    latestChapter: '第156话 剑破云海',
    chapters: 156,
    updateTime: '4小时前',
    views: '2040万',
    updateFrequency: '每日更新',
  },
];

export function getMangaById(id: string): Manga | undefined {
  return MANGAS.find((m) => m.id === id);
}

export function getGenreById(id: string): Genre | undefined {
  return GENRES.find((g) => g.id === id);
}

export function getGenreIdByName(name: string): string {
  return GENRES.find((g) => g.name === name)?.id || '';
}

export function getMangasByGenre(genreId: string): Manga[] {
  const genre = getGenreById(genreId);
  if (!genre) return [];
  return MANGAS.filter((m) => m.genres.includes(genre.name));
}

export function getHotMangas(limit = 6): Manga[] {
  return [...MANGAS].sort((a, b) => b.views.localeCompare(a.views)).slice(0, limit);
}

export function getLatestMangas(limit = 8): Manga[] {
  return MANGAS.slice(0, limit);
}

export function getCompletedMangas(limit = 6): Manga[] {
  return MANGAS.filter((m) => m.status === '已完结').slice(0, limit);
}

export function searchMangas(keyword: string): Manga[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return MANGAS.filter(
    (m) =>
      m.title.toLowerCase().includes(kw) ||
      m.author.toLowerCase().includes(kw) ||
      m.genres.some((g) => g.toLowerCase().includes(kw))
  );
}

export function getRelatedMangas(manga: Manga, limit = 4): Manga[] {
  return MANGAS.filter(
    (m) => m.id !== manga.id && m.genres.some((g) => manga.genres.includes(g))
  ).slice(0, limit);
}